import React, { type ComponentPropsWithRef, type PropsWithChildren } from 'react';

import { Wrapper } from './Styles';

type IconInteractableProps = PropsWithChildren<ComponentPropsWithRef<'span'>>;

/**
 * `Icon`s have `pointer-events: none` by default, so tooltips with icon triggers are not opened.
 * Wrap icons in this component to ensure that they react to hover events.
 */
const IconInteractable = React.forwardRef<HTMLSpanElement, IconInteractableProps>(
  ({ children, ...props }, ref) => (
    <Wrapper {...props} ref={ref}>
      {children}
    </Wrapper>
  ),
);

IconInteractable.displayName = 'IconInteractable';

export default IconInteractable;
